// extracted by mini-css-extract-plugin
export var standaloneTable = "_gy-0";
export var standaloneTableWithBodyFill = "_gy-1";
export var withExtraHeader = "_gy-2";